import Search, { type SearchProps } from '@/storybook/components/Search/Search';
import { useIsDesktop } from '@/utils/useIsDesktop';
import { FC } from 'react';
import styles from './DropdownSearchInput.module.css';

export type DropdownSearchInputProps = {
  'placeholder'?: string;
  'value'?: string;
  'onChange'?: (search: string) => void;
  'data-testid'?: string;
};

const DROPDOWN_SEARCH_DEBOUNCE_MS = 200;
const DROPDOWN_SEARCH_INPUT_ROLE: SearchProps['inputRole'] = 'textbox';
const DROPDOWN_SEARCH_ELEMENT_TEST_IDS = {
  icon: 'searchIcon',
  input: 'input',
  clearButton: 'searchClearButton',
};

const DropdownSearchInput: FC<DropdownSearchInputProps> = ({
  placeholder,
  value,
  onChange,
  'data-testid': dataTestId = 'searchInput',
}) => {
  const isDesktop = useIsDesktop();

  return (
    <div className={styles.searchInputContainer} data-testid={dataTestId}>
      <Search
        autoFocus={isDesktop}
        debounce={DROPDOWN_SEARCH_DEBOUNCE_MS}
        inputRole={DROPDOWN_SEARCH_INPUT_ROLE}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        elementTestIds={DROPDOWN_SEARCH_ELEMENT_TEST_IDS}
      />
    </div>
  );
};

export default DropdownSearchInput;
